import { render, staticRenderFns } from "./supplier-dialog.vue?vue&type=template&id=ad454e72&"
import script from "./supplier-dialog.vue?vue&type=script&lang=js&"
export * from "./supplier-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports